// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W4eAx","field":"styles_field__2RcAB","fieldCol":"styles_fieldCol__17qV3","diffCol":"styles_diffCol__1Jthk","diff":"styles_diff__L6lWu"};